import {
    EntryProcedureModel,
    PreparedDataOnEntryProcedureUpdate,
} from '../../../../types/EntryProcedure';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import { toPreparedDataItems } from './common';

const appendPreparedEntryProcedures = (
    preparedData: PreparedDataOnEntryProcedureUpdate[],
    bumpData: { proceduresToUpdate: EntryProcedureModel[] },
) => {
    return [
        ...preparedData,
        ...toPreparedDataItems(
            bumpData.proceduresToUpdate,
            'entry_procedures',
            'update',
        ),
    ];
};

const logBumpDBActions = ({
    proceduresToUpdate,
    logDBAction,
    tableName,
}: {
    proceduresToUpdate: EntryProcedureModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Bump entry procedures',
        modelName: tableName,
        payload: proceduresToUpdate,
    });
};

export { appendPreparedEntryProcedures, logBumpDBActions };
